module.exports = __webpack_public_path__ + "img/8.85f6bd58.jpg";